import React, {Component} from 'react';
import PropsTypes from 'prop-types'
import {Badge} from "reactstrap"
import {_deleteProxy} from "../../../../../services/apis/ProxiesServices"


const badgeColorMap = {
    active: 'success',
    offline: 'warning',
}

class ProxyRecord extends Component {

    _deleteProxy = () => {
        const {_id} = this.props.record;
        const isDelete = window.confirm('Do you want to delete this proxy')
        if (isDelete) {
            _deleteProxy(_id)
                .then(result => {
                    if (result.success) {
                        this.props.removeProxyFromState(_id);
                        this.props.onRefreshPage();
                    }
                })
        }
    }

    _handleClickEdit = () => {
        this.props.onChangeModalData(this.props.record)
        this.props.onToggleModal()
    }


    render() {
        const {score, uri, status, country, countUsed, countVerify, note} = this.props.record

        return (
            <div className='WorkerRecord'>
                <div className='row table-row'>
                    <div className='col'>{score}</div>
                    <div className='col'>{uri}</div>
                    <div className='col'>{countUsed}</div>
                    <div className='col'>{countVerify}</div>
                    <div className='col'>{country}</div>
                    <div className='col'>{note || ''}</div>
                    <div className='col'>
                        <Badge color={badgeColorMap[status]} pill>{status}</Badge>
                    </div>
                    <div className='col'>
                        <div className="Actions d-flex flex-row">
                            <div className="Action">
                                <button className='btn btn-primary' onClick={this._handleClickEdit}>
                                    Edit
                                </button>
                            </div>

                            <div className="Action">
                                <button className='btn btn-danger' onClick={this._deleteProxy}>
                                    <i className="fas fa-times"/>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

ProxyRecord.propTypes = {
    removeProxyFromState: PropsTypes.func.isRequired,
    onRefreshPage: PropsTypes.func.isRequired,
    record: PropsTypes.object.isRequired,
    onChangeModalData: PropsTypes.func.isRequired,
    onToggleModal: PropsTypes.func.isRequired
}

export default ProxyRecord


// WEBPACK FOOTER //
// ./src/app/pages/dashboard/proxies/component/ProxyRecord.js